// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresSeasonStartPreviewBody = {
  poolId: string;
};

export type typeSquaresSeasonStartPreviewOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    canStart: boolean;
    blockedReason?: "gridsNotFinal" | "noActiveSeason" | null;
    currentSeasonLabel: string;
    nextGamesLabel?: string | null;
    needsInput: "none" | "eventId" | "customDates";
    memberCount: number;
    archivedGridCount: number;
    archivedWinnerCount: number;
  };
};

export type typeSquaresSeasonStartPreviewOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSeasonStartPreviewOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSeasonStartPreviewOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresSeasonStartPreviewBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresSeasonStartPreview(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresSeasonStartPreviewBody);
  }

  return async function postSquaresSeasonStartPreview(
    payload: typeSquaresSeasonStartPreviewBody,
  ): Promise<
    | typeSquaresSeasonStartPreviewOutput200
    | typeSquaresSeasonStartPreviewOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresSeasonStartPreview" failed before calling the network. #7c0525b3a668`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#7c0525b3a668" },
        },
        data: null,
      } as typeSquaresSeasonStartPreviewOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/season-start-preview`,
      httpMethod: "POST",
      options,
    })) as
      | typeSquaresSeasonStartPreviewOutput200
      | typeSquaresSeasonStartPreviewOutput400;
  };
}
